import moment from "moment"
const uuidv4 = require("uuid/v4")
export default class MapperCarrito {
  generarCodigoCarrito(destino, adultos, edades) {
    var arEdades = this.toArray(edades)
    var codigo = destino + "-" + adultos
    arEdades.forEach(function(e) {
      codigo = codigo.concat(e.toString())
    })
    return codigo
  }
  generarValidez(destino, adultos, edades) {
    var codigo = this.generarCodigoCarrito(destino, adultos, edades)
    var stringmenores =
      edades.length > 0
        ? edades.length > 1
          ? " + " + edades.length + " Menores de " + edades.join() + " año/s"
          : "+ " + edades.length + " Menor de " + edades.join() + " año/s"
        : ""
    var valido = {
      codigo: codigo,
      tomado: false,
      descripcion: adultos + " Adulto/s" + stringmenores
    }
    return valido
  }
  esAgregado(validHabCupo, validarSegunBusqueda, aAgregar) {
    // Genera el codigo del carrito para ser usado luego al borrar la habitacion
    var codigo = this.generarCodigoCarrito(
      aAgregar.hotel.destinoBuscador,
      aAgregar.habitacion.tarifas.tarifa["@attributes"].adl,
      aAgregar.habitacion.menores.edades.edad
    )
    var hotel = this.armarHotel(aAgregar, codigo)
    // SI es falso se devuelve en agregar true para pasar validacion de la busqueda
    if (!validarSegunBusqueda) {
      return { agregar: true, hotel: hotel, agregado: codigo }
    }
    // Se valida que la habitacion a agregar exista en ValiabCupo
    const esta = validHabCupo.some(valid => !valid.tomado && valid.codigo == codigo)
    if (esta) {
      return { agregar: true, hotel: hotel, agregado: codigo }
    }
    // no se agrega
    return { agregar: false }
  }
  armarHotel(aAgregar, ocupacion = null) {
    const proveedor = aAgregar.hotel.proveedor
    var habitacion = this.toHabitacion(aAgregar.habitacion, [], [], ocupacion, proveedor)
    var hotel = this.toHotel(
      aAgregar.hotel["@attributes"].id,
      aAgregar.hotel.in,
      aAgregar.hotel.out,
      aAgregar.hotel.nombre,
      aAgregar.hotel.proveedor,
      aAgregar.hotel.destino,
      habitacion,
      aAgregar.hotel.destinoBuscador
    )
    return hotel
  }
  toArray(valor) {
    if (typeof valor === "undefined") {
      return []
    }
    if (!Array.isArray(valor)) {
      return [valor]
    }
    return valor
  }
  toHotel(id, checkin, checkout, nombre, proveedor, destino, habitacion, destinoBuscador) {
    var entrada = moment(checkin)
    var salida = moment(checkout)
    var hotel = {
      unico_carrito: entrada.format("x") + "-" + salida.format("x") + "-" + id + "-" + proveedor,
      id: id,
      in: entrada.format("YYYY-MM-DD"),
      out: salida.format("YYYY-MM-DD"),
      nombre: nombre,
      proveedor: proveedor,
      destino: destino,
      habitaciones: [habitacion],
      destinoBuscador: destinoBuscador
    }
    return hotel
  }
  toHabitacion(habitacionCruda, tickets, planes, ocupacion = null, proveedor, comparador = uuidv4()) {
    var habitacion = {
      comparador: comparador,
      codigo: habitacionCruda.codigo,
      regimen: habitacionCruda["@attributes"].regimen_id,
      promocion: this.tomarPromocion(habitacionCruda, parseInt(proveedor)),
      cancelacionPenalidad: habitacionCruda.cancelacionPenalidad,
      notas: habitacionCruda.notas,
      arrayOfOmniTotal: habitacionCruda.arrayOfOmniTotal,
      omniTotal: habitacionCruda.omniTotal,
      uid: habitacionCruda.uid,
      paymentType: habitacionCruda.paymentType,
      rateRedTuristica: habitacionCruda.rateRedTuristica,
      tarifas: habitacionCruda.tarifas,
      clase: habitacionCruda["@attributes"].clase,
      nombre: habitacionCruda.nombre,
      pase: habitacionCruda["@attributes"].adicional === "true" ? true : false,
      pase_obligatorio: habitacionCruda["@attributes"].pase_obligatorio === "true" ? true : false,
      comida: habitacionCruda["@attributes"].comida === "true" ? true : false,
      comida_obligatorio: habitacionCruda["@attributes"].comida_obligatorio === "true" ? true : false,
      tickets: [],
      comidas: [],
      menores: habitacionCruda.menores,
      ocupacion: ocupacion,
      ticketTipo: habitacionCruda.ticketTipo,
      rq: habitacionCruda.rq
    }
    return { habitacion: habitacion }
  }
  getUnico() {
    return uuidv4()
  }
  tomarPromocion(habitacion, proveedor) {
    switch (proveedor) {
      case 4:
      case 8:
      case 1:
        return habitacion.regimen
      case 11:
      case 9:
        return habitacion.promocion
      case 6156:
        return habitacion["@attributes"].pase_id
      default:
        return ""
    }
  }
}
